/*
 * Copyright © 2022 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FcAgDoubleListComponent} from './fc-ag-double-list.component';

/**
 * Double Select List with Angular.
 */
@NgModule({
    declarations: [
        FcAgDoubleListComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FcAgDoubleListComponent
    ]
})
export class FcAgDoubleListModule {

}
